import React, { createContext, useContext, useEffect } from 'react';
import { useEnterpriseConfig } from '../../hooks/getEnterpriseConfig';

const EnterpriseConfigContext = createContext();

export const useEnterpriseConfigContext = () => {
  const context = useContext(EnterpriseConfigContext);
  if (!context) {
    throw new Error('useEnterpriseConfigContext deve ser usado dentro de um EnterpriseConfigProvider');
  }
  return context;
};

// Função para decodificar o token JWT e extrair o code_client
export const getClientIdFromToken = () => {
  try {
    const token = localStorage.getItem('access_token');
    if (!token) return null;
    
    const tokenData = JSON.parse(atob(token.split('.')[1]));
    
    return tokenData.client_id || null;
  } catch (error) {
    console.error('Erro ao extrair client_id do token:', error);
    return null;
  }
};

export const getEnterpriseIdFromToken = () => {
  try {
    const token = localStorage.getItem('access_token');
    
    if (!token) return null;
    
    const tokenData = JSON.parse(atob(token.split('.')[1]));
    
    return tokenData.enterprise_id || null;
  } catch (error) {
    console.error('Erro ao extrair client_id do token:', error);
    return null;
  }
};

export const EnterpriseConfigProvider = ({ children }) => {
  const enterpriseConfig = useEnterpriseConfig();

  // Aplicar uppercase condicionalmente baseado na configuração do backend e client_id
  useEffect(() => {
    if (!enterpriseConfig.isLoading && enterpriseConfig.settings) {
      // Garantir que text_uppercase seja boolean
      const textUppercase = Boolean(enterpriseConfig.settings.text_uppercase);
      const clientId = getClientIdFromToken();
      
      // Remover todas as classes uppercase-enabled existentes
      document.body.classList.remove('uppercase-enabled');
      document.body.removeAttribute('data-client-id');
      
      // Aplicar apenas se text_uppercase estiver ativado E se houver client_id
      ;
      if (textUppercase && clientId) {
        document.body.classList.add('uppercase-enabled');
        document.body.setAttribute('data-client-id', clientId);
      }
    }
  }, [enterpriseConfig.settings?.text_uppercase, enterpriseConfig.isLoading]);

  return (
    <EnterpriseConfigContext.Provider value={enterpriseConfig}>
      {children}
    </EnterpriseConfigContext.Provider>
  );
};
